export default "__VITE_ASSET__1c862296__"